import React from "react";
import { useLocation } from "react-router"
import { Link, Redirect } from "react-router-dom";
import Header from "../shared/Header/index.jsx";

import * as Styled from './styles.js'

function ErrorPage(props) {
  const location = useLocation()
  var error = 200

  if (location.error !== undefined && location.error !== null) {
    error = location.error

  } else if (props.error) {
    error = props.error
  } 

  return (
      <Styled.Content>
        <Header
            logo={ props.logo }
        />
        {
          error === 200 ?
          <Redirect to={{ pathname: '/' }}/> :
          error ===  404 ?
          <h1>Page not found!</h1> :
          <h1>Error { error }, try again later.</h1>
        }
        <p>
            Click <Link to="/">here</Link> to return to the home page.
        </p>
      </Styled.Content>
  );
}

export default ErrorPage;
